import { CommonBuild, isBuildOnHold, isBuildStarting } from '../models/Build';
import BuildStatus from '../models/BuildStatus';

const getBuildStatusDecorator = (
  build: CommonBuild<'startedAt' | 'startedOnWorkerAt'>,
): {
  textColor: string;
  backgroundColor: string;
} => {
  switch (build.status) {
    case BuildStatus.Running:
      if (build && isBuildOnHold(build)) {
        return {
          backgroundColor: 'status/neutral/bg',
          textColor: 'status/neutral/text',
        };
      }

      if (build && isBuildStarting(build)) {
        return {
          backgroundColor: 'status/info/bg',
          textColor: 'status/info/text',
        };
      }

      return {
        backgroundColor: 'status/progress/bg',
        textColor: 'status/progress/text',
      };
    case BuildStatus.Success:
      return {
        backgroundColor: 'status/success/bg',
        textColor: 'status/success/text',
      };
    case BuildStatus.Error:
      return {
        backgroundColor: 'status/critical/bg',
        textColor: 'status/critical/text',
      };
    case BuildStatus.Aborted:
    case BuildStatus.AbortedWithSuccess:
      return {
        backgroundColor: 'status/warning/bg',
        textColor: 'status/warning/text',
      };
    default:
      return {
        backgroundColor: 'status/neutral/bg',
        textColor: 'status/neutral/text',
      };
  }
};

export default getBuildStatusDecorator;
